"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagExportState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var TagExportState = /** @class */ (function () {
    function TagExportState() {
        this.exporting = false;
    }
    TagExportState.prototype.setExporting = function (loading) {
        this.exporting = loading;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TagExportState.prototype, "exporting", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], TagExportState.prototype, "setExporting", null);
    return TagExportState;
}());
exports.TagExportState = TagExportState;
//# sourceMappingURL=tag.export.state.js.map